import React from 'react';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ size = 'md', ...props }) => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={`${styles.spinner} ${styles[`spinner-${size}`]}`} {...props} />
    </div>
  );
};

export default LoadingSpinner;
